import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/moneymonk.webp';
import screenshot_target from '../../../images/letterfunnel/jorgenhorstink.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Jorgen Horstink"
      firstname="Jorgen"
      companyname="MoneyMonk"
      competition="Moneybird en e-Boekhouden.nl"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jorgenhorstink.js